
export const hasRole = (state, role) => {
    return state.user.roles.indexOf(role) !== -1;
};

export const hasAtLeastOneRole = (state, roles) => {
    let result = false;

    roles.forEach(role => {
        if (hasRole(state, role)) {
            result = true;
        }
    });

    return result;
};

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const rolesHasAccess = (propsRoles, roles) => {
    return !!propsRoles.find(roleName => roles.indexOf(roleName) !== -1);
};

export const isNotSubscriptionType = (propsUser, subscriptionType) => {
    return propsUser.company.subscriptionType != subscriptionType;
}
export const subscriptionTypeHasAccess = (state, subscriptionTypes) => {
    if (subscriptionTypes == undefined) {
        return true;
    }
    let type = '' + state.user.company.subscriptionType; // convert to string
    return (subscriptionTypes.indexOf(type) !== -1);
};



// WEBPACK FOOTER //
// ./web/src/services/access/utils.js